module.exports = __webpack_public_path__ + "static/media/hojadeplata_harinadetrigo.17508c7e.png";